<form [formGroup]="profileForm" class="article-type-masterdata no-field-space">

  <sc-flex>
    <sc-dictionary-field class="input-title" [model]="articleType?.name" [maxlength]="255" [defaultLabel]="'name'"
          [labelDictionaryKey]="'erp.entity.articletype.name'" [required]="true" [grow]="true">
      </sc-dictionary-field>
      <sc-content-spacer></sc-content-spacer>
        <!-- Select Box mit allen ArticleTypes -->
        <mat-form-field appearance="fill" style="width: 300px;">
          <mat-label>{{ 'Parent Article Type' | translate: ['erp.entity.articletype.parentArticleType', translationService.language]}}</mat-label>
          <mat-select formControlName="parentArticleTypeId" [value]="_articleType.parentArticleTypeId">
            <mat-option value="0">{{ 'none' | translate: ['erp.entity.articletype.parentArticleTypeNone', translationService.language]}}</mat-option>
              <mat-option *ngFor="let source of articleTypes" [value]="source.id">
                  {{source.title}}
              </mat-option>
          </mat-select>
        </mat-form-field>
  </sc-flex>  
  

    <sc-content-spacer [vertical]="true"></sc-content-spacer>

    <sc-flex >
      <mat-form-field appearance="fill" class="identifierPattern">
        <mat-label>{{ 'Identifier Pattern' | translate: ['erp.entity.articletype.identifierPattern', translationService.language]}}</mat-label>
        <input matInput formControlName="identifierPattern">
      </mat-form-field>

      <sc-content-spacer></sc-content-spacer>

      <mat-checkbox name="archived" formControlName="archived">
        {{'archived' | translate: ['erp.entity.articletype.archived', translationService.language]}}
      </mat-checkbox>
    </sc-flex>

</form>
